import { SxProps, Theme } from "@mui/material";
import colors from "../../theme/Colours";

export const getContainerBoxStyle = (isMobile: boolean): SxProps<Theme> => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "space-evenly",
  alignItems: "center",
  padding: isMobile ? "24px" : "48px",
  gap: isMobile ? "24px" : "0",
});

export const getLeftBoxStyle = (isMobile: boolean): SxProps<Theme> => ({
  width: isMobile ? "100%" : "35%",
  justifyContent: "space-between",
});

export const getRightBoxStyle = (isMobile: boolean): SxProps<Theme> => ({
  width: isMobile ? "100%" : "33%",
  marginTop: isMobile ? "0" : "-50px",
});

export const getHeadingTextStyle = (isMobile: boolean): SxProps<Theme> => ({
  fontWeight: 500,
  fontSize: isMobile ? "24px" : "32px",
  paddingBottom: "8px",
});

export const subTextStyle: SxProps<Theme> = {
  fontSize: "16px",
  paddingBottom: "40px",
  color: "#828282",
};

export const passwordValidationBoxStyle: SxProps<Theme> = {
  margin: "8px",
  padding: "8px",
  borderRadius: "10px",
  backgroundColor: "#F9FAFB4D",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
};

export const getPasswordValidationTextStyle = (
  isValid: boolean
): SxProps<Theme> => ({
  fontSize: "12px",
  fontWeight: 400,
  color: isValid ? colors.progressColor : colors.redText,
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export const updateButtonStyle: SxProps<Theme> = {
  marginTop: "16px",
};
